import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import { Environment } from '../../../shared/environment';

interface ItensImpr {
  descricao: string;
  quantidade: number;
};
 
export interface IgetImpressaoNota {
  idtalao: string;
  numero: string;
  datalan: Date;
  nome: string;
  cpf: string;
  rg: string;
  fantasia: string;
  endereco: string;
  bairro: string;
  municipio: string;
  uf: string;
  celular: string;
  logo: string;
  cep: string;
  itens: ItensImpr[];
}
  
async function PDFTalaoPequeno(dados: IgetImpressaoNota){

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  
    async function getBase64ImageFromUrl(url: string): Promise<string> {
      return new Promise((resolve, reject) => {
        const img: HTMLImageElement = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          const canvas: HTMLCanvasElement = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject('Não foi possível obter o contexto 2D');
            return;
          }
          const image = this as HTMLImageElement;
          canvas.height = image.naturalHeight;
          canvas.width = image.naturalWidth;
          ctx.drawImage(image, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = function () {
          reject(`Não foi possível carregar a imagem de ${url}`);
        };
        img.src = url;
      });
    }
  
    const imageUrl = Environment.URL_IMGFABRICA + dados.logo || '';
    const imageData = await getBase64ImageFromUrl(imageUrl);
  
    if (!imageData.startsWith('data:image')) {
      return new Error('A imagem não foi convertida corretamente para base64.');
    }
  
    const rows = dados.itens.map((row) => {
      return [
        {
          text: row.descricao,
          fontSize: 8,
          alignment: 'left',
        },
        {
          text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.quantidade),
          alignment: 'right',
          fontSize: 8,
        },
      ];
    });
  
    // Calcular total de itens
    const totalItens = dados.itens.reduce((acc, item) => acc + (item.quantidade || 0), 0);
  
    const documentDefinition: any = {
      pageSize: { width: 226.77, height: 'auto' }, // 80mm
      pageMargins: [5, 10, 5, 10],
      content: [
        {
          style: 'tableExample',
          table: {
            widths: ['auto', '*'],
            body: [
              [
                {
                  image: imageData,
                  width: 60,
                  alignment: 'left',
                  border: [false, false, false, false],
                },
                {
                  text: 'TALÃO DE PEDIDO',
                  fontSize: 12,
                  alignment: 'left',
                  margin: [5, 2, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  colSpan: 2,
                  border: [false, false, false, false],
                  margin: [10, 5, 0, 5],
                  table: {
                    widths: ['*', '*'],
                    body: [
                      [
                        {
                          text: dados.celular || '(71) 9984-9999',
                          fontSize: 10,
                          alignment: 'center',
                          border: [false, false, false, false],
                        },
                        {
                          text: `PEDIDO Nº ${dados.numero}`,
                          fontSize: 10,
                          alignment: 'center',
                          border: [false, false, false, false],
                        },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
                {},
              ],
            ],
          },
        },
        {
          margin: [0, 5, 0, 5],
          table: {
            widths: ['*'],
            body: [
              [{ text: `Cliente: ${dados.nome}`, fontSize: 9 }],
              [{ text: `Nome Fantasia: ${dados.fantasia || '-----------'}`, fontSize: 9 }],
              [{ text: `CPF/CNPJ: ${dados.cpf}   RG/IE: ${dados.rg || '-----------'}`, fontSize: 9 }],
              [{ text: `Emissão: ${moment(dados.datalan).format('DD/MM/YYYY')}`, fontSize: 9 }],
              [{ text: `Endereço: ${dados.endereco}, ${dados.bairro}`, fontSize: 9 }],
              [{ text: `Município: ${dados.municipio} - ${dados.uf}`, fontSize: 9 }],
              [{ text: `CEP: ${dados.cep ? dados.cep.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2-$3') : '-----------'}`, fontSize: 9 }],
              [{ text: `Telefone: ${dados.celular || '-----------'}`, fontSize: 9 }],
            ],
          },
        },
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['*', 50],
            body: [
              [
                { text: 'Descrição', alignment: 'left', fillColor: '#eeeeee', fontSize: 8, bold: true },
                { text: 'Qtd.', alignment: 'right', fillColor: '#eeeeee', fontSize: 8, bold: true },
              ],
              ...rows,
            ],
          },
        },
        {
          margin: [0, 5, 0, 0],
          table: {
            widths: ['*', 50],
            body: [
              [
                {
                  text: 'Total de Itens:',
                  fontSize: 9,
                  bold: true,
                  alignment: 'left',
                  border: [false, false, false, false],
                },
                {
                  text: new Intl.NumberFormat('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(totalItens),
                  fontSize: 9,
                  bold: true,
                  alignment: 'right',
                  border: [false, false, false, false],
                },
              ],
            ],
          },
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 33.385,
              y1: 0,
              x2: 193.385,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 20, 0, 0],
        },
        {
          text: 'ASS. COMPRADOR',
          alignment: 'center',
          margin: [0, 2, 0, 0],
          fontSize: 9,
          bold: true,
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 33.385,
              y1: 0,
              x2: 193.385,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 30, 0, 0],
        },
        {
          text: 'VENDEDOR',
          alignment: 'center',
          margin: [0, 2, 0, 10],
          fontSize: 9,
          bold: true,
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [
              [{ text: `Data Entrega: ____/_____/_______`, alignment: 'left', fontSize: 9, border: [false, false, false, false] }],
              [{ text: `Local de Entrega: ___________________________________`, alignment: 'left', fontSize: 9, border: [false, false, false, false] }],
            ],
          },
        },
      ],
    };
  
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.open();
}

export default PDFTalaoPequeno;